export default __webpack_public_path__ + "static/media/cars-parked-company-office.b900fce9.jpg";